<template>
  <div
    class="
      v-modal-window
      v-modal-window__layout__indexed
    "
    v-if="isActive"
  >
    <div class="v-modal-window__window-container__vertical-centered">
      <div class="v-modal-window__window-container__horisontal-centered">
        <div class="v-modal-window__window">
          <div class="v-modal-window__close-button-container">
            <div class="v-modal-window__close-button" @click="toggle()">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30">
                <g fill="#384656" fill-rule="evenodd">
                  <path d="M.751 1.24L1.7.293l28.415 28.416-.947.947z"></path>
                  <path d="M1.699 29.656L.75 28.71 29.167.293l.947.947z"></path>
                </g>
              </svg>
            </div>
          </div>
          <div class="v-modal-window__content-container">
            <slot/>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'VModalWindow',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'isActive',
    event: 'toggle'
  },
  methods: {
    toggle(){
      this.$emit('toggle', !this.isActive);

      return this.isActive;
    }
  }
}
</script>

<style>
.v-modal-window {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: table;
}

.v-modal-window__layout__indexed {
  z-index: 100;
}

.v-modal-window__window-container__vertical-centered {
  display: table-cell;
  vertical-align: middle;
}

.v-modal-window__window-container__horisontal-centered {
  display: flex;
  justify-content: center;
}

.v-modal-window__window {
  max-width: 1000px;
  width: 100%;
  background: rgb(255, 255, 255);
  font-family: PlumbLightC, sans-serif;
  color: #384656;
  border-radius: 15px;
}

.v-modal-window__close-button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.v-modal-window__close-button {
  margin: 20px 20px 0 0;
  cursor: pointer;
}

.v-modal-window__content-container {
  margin: 10px 60px;
}

@media only screen and (max-width: 1290px) {
  .v-modal-window__window {
    max-width: 580px;
    margin: 35px 0;
  }
}

@media only screen and (max-width: 600px) {
  .v-modal-window__window {
    min-height: 100%;
    margin: 0;
    border-radius: 0;
  }

  .v-modal-window__content-container {
    margin: 10px 5px;
  }
}
</style>

